<template>
  <footer class="footer-box" :class="from==='home'?'orange':''">
    <div class="footer-box-top">
      <div class="footer-left">
        <div class="footer-nav">
          <span>关于我们</span>
          <a :href="prePath+'/about/company'" target="_blank">认识云族佳</a>
          <a :href="prePath+'/about'" target="_blank">云沃客简介</a>
        </div>
        <div class="footer-nav">
          <span>协议与声明</span>
          <a :href="prePath+'/legal/privacy'" target="_blank">注册协议</a>
          <a :href="prePath+'/legal'" target="_blank">用户协议</a>
          <a :href="prePath+'/intellectual-property'" target="_blank">知识产权声明</a>
        </div>
        <div class="footer-nav">
          <span>帮助中心</span>
          <a href="//www.clouderwork.com/help/topic/28" target="_blank">【项目众包】相关</a>
          <a href="//www.clouderwork.com/help/topic/25" target="_blank">【黄豆纳才】相关 </a>
          <a href="//www.clouderwork.com/help/topic/27" target="_blank">【企业版】相关</a>
        </div>
        <div class="footer-nav">
          <span>发现</span>
          <a :href="entUrl+'/app/monitor'" nofollow target="_blank">绩效管理工具</a>
          <a :href="entUrl+'/task/desks'">项目协作工具</a>
          <a :href="prePath+'/case'" target="_blank">成功案例</a>
          <a :href="prePath+'/app'" target="_blank">下载APP</a>
        </div>
        <div class="footer-nav">
          <span>合作</span>
          <a :href="prePath+'/contactus'" target="_blank" nofollow>联系我们</a>
        </div>
      </div>
      <div class="footer-right">
        <img v-if="from=='home'" class="logo-img" src="../assets/images/common/footer-logo-white.png" />
        <img v-else class="logo-img" src="../assets/images/common/footer-logo.png" />
        <p class="tell">客服电话：400-068-0020</p>
        <p class="week">周一至周五  9：00-18：00</p>
        <div class="footer-icon">
          <div class="item wechat">
            <img class="code" src="../assets/images/common/wechat-code.png" />
          </div>
          <a href="http://wpa.qq.com/msgrd?v=3&uin=2330853761&site=qq&menu=yes" target="_blank" class="item qq"></a>
          <a href="http://weibo.com/yunzujia" target="_blank" class="item weibo"></a>
        </div>
      </div>
    </div>
    <div class="footer-box-bottom">
      <p><a href="https://www.clouderwork.com/static/images/cert/hr.jpg" target="_blank">人力资源服务许可证 京人社[2017] 110105717578号</a> | <a :href="prePath+'/static/images/cert/icp.png'" target="_blank">增值电信业务经营许可证 京B2-20192450</a> | <a href="http://www.beian.miit.gov.cn/" nofollow target="_blank">京ICP备13050812号</a></p>
      <p><a href="https://www.clouderwork.com/static/images/cert/cb.jpg" target="_blank">互联网出版许可证 京字第200号</a> | <a href="https://www.clouderwork.com/static/images/cert/gaoxin.jpg" target="_blank">高新企业证书</a> | <a href="https://www.clouderwork.com/static/images/cert/rj1.jpg" target="_blank">软件产品证书</a> | <a href="https://www.clouderwork.com/static/images/cert/rj2.jpg" target="_blank">软件企业证书</a> | <a href="https://www.clouderwork.com/static/images/cert/zl1.jpg" target="_blank">质量管理体系认证证书1</a> | <a href="https://www.clouderwork.com/static/images/cert/zl2.jpg" target="_blank">质量管理体系认证证书2</a></p>
      <p><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11030102010742" target="_blank">
          <img src="../assets/images/icons/icon-beian.png"> 京公网安备 11030102010742号</a> | © 2020 云族佳科技有限公司版权所有</p>
    </div>
    <div class="footer-fix" @click="scrollToTop" v-show="showGoBtn">
      <p>回到顶部</p>
    </div>
  </footer>
</template>
<script>
export default {
  data () {
    return {
      showGoBtn: false
    }
  },
  props: {
    from: {
      type: String,
      default: ''
    }
  },
  created () {
    this.$nextTick(() => {
      document.addEventListener('scroll', (e) => {
        this.showGoBtn = document.body.scrollTop > document.body.clientHeight || document.documentElement.scrollTop > document.body.clientHeight
      }, false)
    })
  },
  computed: {
    // 网站前缀
    prePath () {
      /* eslint-disable no-undef */
      return WWW_DOMAIN
    },
    entUrl () {
      /* eslint-disable no-undef */
      return ENT_DOMAIN
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
<style lang="postcss" scoped>
.footer-box {
  width: 100%;
  background-color: #fafafa;
  position: absolute;
  bottom: 0;
  overflow: hidden;
  border-top: 1px solid #f8f8f8;
  &.orange {
    background: #ff6710;
    .footer-box-top {
      span,a,p {
        color: #fff !important;
      }
    }
    .footer-nav {
      &:nth-child(1) span {
        background: url('../assets/images/common/footer-about.png') no-repeat left;
        &:hover {
          background: url('../assets/images/common/footer-about.png') no-repeat left;
        }
      }
      &:nth-child(2) span {
        background: url('../assets/images/common/footer-guide.png') no-repeat left;
        &:hover {
          background: url('../assets/images/common/footer-guide.png') no-repeat left;
        }
      }
      &:nth-child(3) span {
        background: url('../assets/images/common/footer-help.png') no-repeat left;
        &:hover {
          background: url('../assets/images/common/footer-help.png') no-repeat left;
        }
      }
      &:nth-child(4) span {
        background: url('../assets/images/common/footer-find.png') no-repeat left;
        &:hover {
          background: url('../assets/images/common/footer-find.png') no-repeat left;
        }
      }
      &:nth-child(5) span {
        background: url('../assets/images/common/footer-coop.png') no-repeat left;
        &:hover {
          background: url('../assets/images/common/footer-coop.png') no-repeat left;
        }
      }
    }
    .footer-right {
      p:before {
        background: #fff;
      }
      .footer-icon {
        .wechat {
          width: 24px;
          height: 20px;
          margin-right: 36px;
          background: url('../assets/images/common/footer-wechat.png') no-repeat center;
        }
        .qq {
          width: 20px;
          height: 24px;
          margin-right: 35px;
          background: url('../assets/images/common/footer-qq.png') no-repeat center;
        }
        .weibo {
          width: 24px;
          height: 20px;
          background: url('../assets/images/common/footer-weibo.png') no-repeat center;
        }
      }
    }
  }
}
.footer-box-top {
  width: 1200px;
  margin: auto;
  overflow: hidden;
  padding: 55px 0 60px;
  box-sizing: border-box;
  .footer-left {
    float: left;
    width: 950px;
    padding-left: 30px;
  }
  .footer-right {
    float: right;
    height: 215px;
    .logo-img {
      display: inline-block;
      width: 180px;
      height: auto;
    }
    .footer-icon {
      display: inline-block;
      margin-top: 30px;
      margin-left: 15px;

      .item {
        display: inline-block;
        cursor: pointer;
      }

      .wechat {
        width: 24px;
        height: 20px;
        background: url('../assets/images/common/wechat.png') no-repeat center center;
        background-size: contain;
        margin-right: 47px;
        position: relative;

        .code {
          display: none;
          width: 130px;
          height: 130px;
          position: absolute;
          top: -135px;
          left: -60px;
        }

        &:hover {
          background: url('../assets/images/common/wechat-s.png') no-repeat center center;

          .code {
            display: inline-block;
          }
        }
      }

      .qq {
        width: 20px;
        height: 24px;
        background: url('../assets/images/common/qq.png') no-repeat center center;
        background-size: contain;
        margin-right: 47px;

        &:hover {
          background: url('../assets/images/common/qq-s.png') no-repeat center center;
        }
      }

      .weibo {
        width: 24px;
        height: 20px;
        background: url('../assets/images/common/weibo.png') no-repeat center center;
        background-size: cover;

        &:hover {
          background: url('../assets/images/common/weibo-s.png') no-repeat center center;
        }
      }
    }

    p {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #666;
      letter-spacing: 0;
      line-height: 18px;
      &:before {
        content: '';
        display: inline-block;
        background: #ff7a05;
        width: 6px;
        height: 6px;
        border-radius: 100%;
        margin-right: 10px;
        position: relative;
        top: -3px;
      }
    }

    .week {
      margin-top: 9px;
    }
  }
  .footer-nav {
    float: left;
    margin-right: 50px;
    padding-right: 45px;
    height: 185px;
    box-sizing: border-box;
    border-right: 1px dashed #d0cdcd;
    &:nth-child(1) span {
      background: url('../assets/images/common/footer-about-gray.png') no-repeat left;
      &:hover {
        background: url('../assets/images/common/footer-about-orange.png') no-repeat left;
      }
    }
    &:nth-child(2) span {
      background: url('../assets/images/common/footer-guide-gray.png') no-repeat left;
      &:hover {
        background: url('../assets/images/common/footer-guide-orange.png') no-repeat left;
      }
    }
    &:nth-child(3) span {
      background: url('../assets/images/common/footer-help-gray.png') no-repeat left;
      &:hover {
        background: url('../assets/images/common/footer-help-orange.png') no-repeat left;
      }
    }
    &:nth-child(4) span {
      background: url('../assets/images/common/footer-find-gray.png') no-repeat left;
      &:hover {
        background: url('../assets/images/common/footer-find-orange.png') no-repeat left;
      }
    }
    &:nth-child(5) span {
      background: url('../assets/images/common/footer-coop-gray.png') no-repeat left;
      &:hover {
        background: url('../assets/images/common/footer-coop-orange.png') no-repeat left;
      }
    }

    span {
      display: block;
      font-size: 20px;
      color: #ff6710;
      margin-bottom: 35px;
      padding-left: 30px;
      margin-left: -30px;
    }
    a {
      display: block;
      font-size: 14px;
      color: #666;
      line-height: 19px;
      margin-top: 18px;
    }
    a:hover {
      color: #ff6710;
    }
  }
}

.footer-box-bottom {
  width: 100%;
  background-color: #333;
  color: #999;
  font-size: 12px;
  text-align: center;

  p {
    font-family: MicrosoftYaHei;
    letter-spacing: 0;
    line-height: 16px;
    padding-top: 20px;

    &:last-child {
      padding: 10px 0 20px;
    }

    a {
      color: #999;
      text-decoration: none;
      vertical-align: middle;

      img {
        display: inline-block;
        width: 16px;
        height: auto;
        vertical-align: bottom;
      }
      &:visited,&:hover {
        text-decoration: none;
      }
    }
  }

}

.footer-fix {
  position: fixed;
  right: 0;
  bottom: 117px;
  border-radius: 2px;
  width: 50px;
  height: 50px;
  padding: 0 16px;
  cursor: pointer;
  overflow: hidden;
  transition: 0.3s;
  background: #b5b5b5 url('../assets/images/common/footer-top.png') no-repeat 18px center;
  p {
    display: none;
    font-size: 14px;
    font-weight: lighter;
    color: #fff;
    letter-spacing: 1.15px;
    line-height: 50px;
  }
  &:hover {
    background: #ff6710 url('../assets/images/common/footer-top.png') no-repeat 87px center;
    width: 119px;
    p {
      display: block;
    }
  }
}
</style>
